import * as React from 'react'

import * as FiltersStore from '@store/filters/filters'

import ScreenContainer from '@components/screenContainer/screenContainer'
import BusinessesMenu from '@components/menu/businessesMenu'
import BusinessesMap from '@components/map/businessesMap'

interface Props {
  navigation: Navigation
}

const Home = ({ navigation }: Props) => {
  const [screenStatus, setScreenStatus] = React.useState<ScreenStatus>('loading')

  const [businesses, setBusinesses] = React.useState<BusinessResume[]>([])
  const [clusters, setClusters] = React.useState<Cluster[]>([])
  const [isolatedBusinesses, setIsolatedBusinesses] = React.useState<BusinessLocation[]>([])
  const [mapBusinesses, setMapBusinesses] = React.useState<BusinessResume[]>([])
  const [orphans, setOrphans] = React.useState<OrphanDeclarationResume[]>([])

  const [orphansVisible, setOrphansVisible] = React.useState<boolean>(FiltersStore.store.getState().orphanVisible)

  React.useEffect(() => {
    setMapBusinesses(businesses.filter((b) => !!b.latitude && !!b.longitude))
  }, [businesses])

  const handleOrphansVisibleChanged = (v: boolean) => {
    setOrphansVisible(v)
    FiltersStore.actions.setOrphansVisible(v)
  }

  return (
    <ScreenContainer
      menu={
        <BusinessesMenu
          navigation={navigation}
          screenStatus={screenStatus}
          setScreenStatus={setScreenStatus}
          businesses={businesses}
          setBusinesses={setBusinesses}
          setClusters={setClusters}
          setIsolatedBusinesses={setIsolatedBusinesses}
          setOrphans={setOrphans}
          orphansVisible={orphansVisible}
          setOrphansVisible={handleOrphansVisibleChanged}
          orphansCount={orphans.length}
          mapBusinessesCount={mapBusinesses.length}
        />
      }
      content={
        <BusinessesMap
          navigation={navigation}
          orphansVisible={orphansVisible}
          clusters={clusters}
          isolatedBusinesses={isolatedBusinesses}
          orphans={orphans}
          screenStatus={screenStatus}
        />
      }
    />
  )
}

export default Home
